(function () {
  const switcherItems = [ ...document.querySelectorAll('.switcher-container .switcher-item')];
  const clickHandler = ({ target }) => {
    if (target.classList.contains('active')) {
      return;
    }

    const { parentElement: { id } } = target;

    document.querySelector(`#${id}.switcher-container .active`).classList.remove('active');
    target.classList.add('active');
  }
  
  switcherItems.map((item) => {
    item.onclick = clickHandler
  })
})();
